



































import { mapState, mapGetters } from 'vuex';
import axios from 'axios';
import { DateTime } from 'luxon';
import { UtilService, Formatter } from '@/services';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import { BTable } from 'bootstrap-vue';
import { DateRange, DataLoaderParams } from '@/types';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faEdit, faTrash } from '@fortawesome/pro-light-svg-icons';
library.add(faEdit, faTrash);

@Component({ name: 'base-B' })
export default class BaseB extends Vue {
  protected isBusy: boolean = false;
  protected fields: object = {};
  protected title: string | null = null;
  protected sortBy: string | null = null;
  protected sortDesc: boolean = true;
  protected perPage: number = 30;
  protected totalRows: number = 0;
  protected dataKey: string = 'data';
  protected summary: boolean = false;
  protected SSD: any = {};
  protected fmt!: Formatter;
  protected itemPK: string = 'id';
  protected editRoute: string | null = null;
  protected withDateRange: boolean = true;

  // todo fix the type
  @State(state => state.AppMod.dateRange)
  dateRange!: DateRange;

  @Watch('dateRange')
  onDateRangeChanged(): void {
    (this.$refs.table as BTable).refresh();
  }

  get currentPage() {
    const page = this.$route.query.page;
    return parseInt(page ? page : '1');
  }

  set currentPage(page: number) {
    this.$router.replace({ query: { page: `${page}` } });
  }

  getRowItems(ssd: any): any {
    return (this.dataKey ? ssd[this.dataKey] : ssd).data;
  }

  setPagination(ssd: any): void {
    const { paginatorInfo } = ssd[this.dataKey];
    this.totalRows = paginatorInfo.total;
    this.currentPage = paginatorInfo.currentPage;
  }

  // on server side data load internal event handler
  onSSD(ssd: any): any {
    return ssd;
  }

  onRowClicked(item: any): void {
    this.$router.push(`${this.editRoute}/${item[this.itemPK]}/edit`);
  }

  editHandler(item: any): void {
    this.$router.push(`${this.editRoute}/${item[this.itemPK]}/edit`);
  }
  deleteHandler(item: any): void {}

  setTitle(ssd: any): void {}

  async dataLoader(params: DataLoaderParams): Promise<any> {}

  async itemsProvider(ctx: any) {
    this.$emit('loading');
    const dateRangeFilter = this.withDateRange
      ? {
          since: UtilService.toEpoch(this.dateRange[0]),
          until: UtilService.toEpoch(this.dateRange[1])
        }
      : {};
    const params: DataLoaderParams = {
      first: this.perPage,
      page: ctx.currentPage,
      filters: {
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
        ...dateRangeFilter
      }
    };

    try {
      const ssd = await this.dataLoader(params);
      this.onSSD(ssd);
      this.setPagination(ssd);

      return this.getRowItems(ssd);
    } catch (e) {
      this.isBusy = false;
    }
  }

  created() {
    this.fmt = UtilService.formatter;
    this.editRoute = this.editRoute ? this.editRoute : this.$route.path;
  }
}
